/**
 * Los datos INVENTADOS de la credencial de ejemplo (la home y /certificado). Se dibujan con
 * la misma tarjeta que una real, siempre con la variante `example` —que le pone la marca de
 * agua— para que una captura suelta no circule como si fuera una credencial emitida.
 *
 * El código tiene forma válida pero no existe: /certificado/A1B2C3D4E5F6 responde "no
 * encontramos ninguna credencial", que es lo correcto para un ejemplo.
 */
export const SAMPLE_CREDENTIAL = {
  holderName: "Nombre Apellido",
  courseTitle: "Introducción a la Inteligencia Artificial",
  issuedAt: "2026-07-15T15:00:00.000Z",
  completedAt: "2026-07-15T15:00:00.000Z",
  code: "A1B2C3D4E5F6",
} as const;
